import { __assign } from "tslib";
import { selectors as streamSelectors } from '../../Stream';
var statMap = {
    comment: 'comments',
    favourite: 'favourites',
};
function getStreamIdForType(type, deviationId) {
    return "@@who:".concat(deviationId, ":").concat(type);
}
function getTotal(state, type, deviation) {
    var streamId = getStreamIdForType(type, deviation.deviationId);
    var streamTotal = streamSelectors.getTotal(state, streamId);
    // fall back to deviation stats as default
    if (streamTotal === undefined) {
        var stats = __assign(__assign({}, deviation.stats), (deviation.extended && deviation.extended.stats));
        return stats[statMap[type]] || 0;
    }
    return streamTotal;
}
export function getUserStreamContents(state, type, deviation) {
    var streamId = getStreamIdForType(type, deviation.deviationId);
    return {
        streamId: streamId,
        users: streamSelectors.getItems(state, streamId),
        isFetching: streamSelectors.isFetching(state, streamId),
        isInitialized: streamSelectors.isInitialized(state, streamId),
        total: getTotal(state, type, deviation),
    };
}
//# sourceMappingURL=selectors.js.map